export const PODIUM_COLOURS = ['#FFD700', '#C0C0C0', '#CD7F32'];
export const PODIUM_BG = ['rgba(255,215,0,0.06)', 'rgba(192,192,192,0.05)', 'rgba(205,127,50,0.05)'];

// rows must already be sorted by score desc. Ties share a rank (competition ranking).
export function computeRanks(rows, scoreKey = 'score') {
  const scores = rows.map(r => r[scoreKey] ?? 0);
  return scores.map((score, i) => scores.indexOf(score) + 1);
}

// Groups rows into { 1: [rows...], 2: [...], 3: [...] } for podium display.
// A key is absent if too few entries exist; a rank may hold >1 row if tied.
export function topThreeGroups(rows, scoreKey = 'score') {
  const ranks = computeRanks(rows, scoreKey);
  const groups = {};
  rows.forEach((row, i) => {
    const rank = ranks[i];
    if (rank > 3) return;
    (groups[rank] ??= []).push(row);
  });
  return groups;
}
